{
  "id": "campaign-011",
  "name": "Lucky Lawn",
  "seed": "campaign:11",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "...........",
    "......T..T.",
    ".....B.....",
    ".....,.....",
    ".....,,....",
    ".....,.....",
    ".....B.....",
    "..#..,,,...",
    "...........",
    "...........",
    "...........",
    "...........",
    "S...#......"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 10,
      "y": 5
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 0,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    }
  ],
  "generatorVersion": 3,
  "level": 11,
  "biome": "backyard",
  "par": {
    "reel": 5602,
    "push": 4599,
    "selfPropelled": 4218,
    "tractor": 3575,
    "zeroTurn": 2942,
    "fairway": 1620
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 4,
      "selfPropelled": 22,
      "tractor": 0,
      "zeroTurn": 6,
      "fairway": 4
    }
  }
}
